module.exports = __webpack_public_path__ + "img/puberty-decal-20.d68246e9.png";